module.exports = __webpack_public_path__ + "img/monitoring.3dee06db.gif";